// https://codepen.io/anon/pen/gQKgbE
// https://github.com/Polymer/lit-html/issues/423
// https://github.com/Polymer/lit-element/issues/313

import { LitElement, svg } from 'lit-element';
import { directive } from 'lit-html';

const XLINK = 'http://www.w3.org/1999/xlink';

const namespacedAttr = directive((namespace, value) => (part) => {
	part.committer.element.setAttributeNS(namespace, part.committer.name, value);
});

class Icon extends LitElement {
	static get properties() {
		return {
			icon: { type: String },
			size: { type: String },
		};
	}

	constructor() {
		super();

		this.size = 's';
		this.icon = '';
	}

	render() {
		const href = `/icons/sprite.svg#${this.icon}`;

		return svg`
			<svg viewBox="0 0 16 16" class="icon icon--${this.size}">
				<use xmlns:xlink="${XLINK}" xlink:href='${namespacedAttr(XLINK, href)}'></use>
			</svg>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-icon', Icon);

export default Icon;

